<script lang="ts">
    import type { DesignModeProviderInterface } from "@modules/common_module/DesignModeProvider/DesignModeProviderInterface";

    //Props
    export let designModeProvider: DesignModeProviderInterface;

    const isDesignMode = designModeProvider.isDesignMode();
</script>

<div
    class:gw-rd-design-mode-guard={isDesignMode}
    inert={isDesignMode ? true : undefined}
>
    <slot />
</div>

<style>
    .gw-rd-design-mode-guard {
        pointer-events: none;
        user-select: none;
        cursor: none;
    }
</style>
